import { useCallback } from 'react'
import { CalendarEvent } from '@highlight/common'
import AudioNoteIpcRenderer from '@renderer/ipc/AudioNoteIpc.renderer'

export interface AwaitMeetingJoinOptions {
  source: 'base' | 'toast'
  meeting: CalendarEvent
  onSuccessfulStart?: () => void
}

/**
 * Hook for deferring meeting recording until the meeting is actually detected.
 * Opens the meeting URL and waits for meeting detection to auto-start recording.
 */
export const useAwaitMeetingJoin = () => {
  return useCallback(async (options: AwaitMeetingJoinOptions) => {
    const { meeting, onSuccessfulStart } = options
    await AudioNoteIpcRenderer.startAwaitingMeetingJoin(meeting)
    onSuccessfulStart?.()
  }, [])
}
